import { fanduel as fd } from "@fanduel/formation-tokens";
import cx from "classnames";
import styles from "../nflMatchupCard.module.scss";
interface LiveGameStatLineProps {
  homeStat: number;
  awayStat: number;
  statName: string;
  homeColor?: string | null;
  awayColor?: string | null;
}

const calculatePercentage = (homeStat: number, awayStat: number): number => {
  if (homeStat === 0 && awayStat === 0) {
    return 50;
  }
  if (homeStat === 0 && awayStat > 0) {
    return 0;
  }
  return (homeStat / (homeStat + awayStat)) * 100;
};

const LiveGameStatLine = ({
  homeStat,
  awayStat,
  statName,
  homeColor,
  awayColor,
}: LiveGameStatLineProps) => {
  const homeStatPercentage = calculatePercentage(homeStat, awayStat);
  return (
    <div className={styles.liveGameStatContainer}>
      <h3>{statName}</h3>
      <div className={styles.liveGameStat}>
        <p className={styles.statRank}>{Math.round(awayStat)}</p>
        <div className={styles.statLine}>
          <div
            className={styles.fillBar}
            data-testid="fillBar"
            style={{
              left: 0,
              width: `calc(${Math.max(Math.min(100 - homeStatPercentage, 98), 2)}% - 2px)`,
              backgroundColor: awayColor ?? fd.colors.brandPrimaryDefault,
            }}
          />
          <div
            className={styles.fillBar}
            style={{
              right: 0,
              width: `calc(${Math.max(Math.min(homeStatPercentage, 98), 2)}% - 2px)`,
              backgroundColor: homeColor ?? fd.colors.brandPrimaryDefault,
            }}
          />
        </div>
        <p className={cx(styles.leftStat, styles.statRank)}>
          {Math.round(homeStat)}
        </p>
      </div>
    </div>
  );
};

export default LiveGameStatLine;
